const ShowResponseIfError = (response) => {
  if (!response.ok) {
    let err = new Error("HTTP status code: " + response.status);
    err.response = response;
    err.status = response.status;
    throw err;
  }
};

const CreateHeaders = (initial_headers) => {
  const token = localStorage.getItem("fh_access_token");
  let headers = {...initial_headers};
  if (token) {
    headers["authorization"] = `Bearer ${token}`;
  }
  return headers;
}

export const CreateAuthHeaders = (token_storage_name) => {
  const token = localStorage.getItem(token_storage_name);
  let headers = {};
  if (token) {
    headers["authorization"] = `Bearer ${token}`;
  }
  return headers;
}

export const FetchPost = (url, headers, postdata) => {
  return new Promise((resolve, reject) => {
    fetch(url, {
      body: JSON.stringify(postdata),
      headers: {"content-type": "application/json", ...headers},
      method: "POST"
    })
      .then((response) => {
        if (response.redirected) {
          window.location.href = response.url;
        }
        else {
          ShowResponseIfError(response);
          if (response.status === 204) {
            return null;
          }
          else {
            return response.json();
          }
        }
      })
      .then((js) => {
        if (js == null) {
          resolve(js)
        }
        else {
          if ("result" in js) resolve(js.result);
          else resolve(js);
        }
      })
      .catch((e) => reject(e));
  });
};

export const FetchGet = (url, headers) => {
  return new Promise((resolve, reject) => {
    fetch(url, { method: "GET", headers })
      .then((response) => {
        if (response.redirected) {
          window.location.href = response.url;
        }
        else {
          ShowResponseIfError(response);
          if (response.status === 204) {
            return null;
          }
          else {
            if (response.headers.get("content-type").includes("application/json")) {
              return response.json();
            } else {
              return response.text();
            }
          }
        }
      })
      .then((js) => {
        if (js == null) {
          resolve(js)
        }
        else {
          if (typeof js === "string") {
            resolve(js);
          }
          else {
            if ("result" in js) resolve(js.result);
            else resolve(js);
          }
        }
      })
      .catch((e) => reject(e));
  });
};

export const FetchPatch = (url, headers, data) => {
  return new Promise((resolve, reject) => {
    fetch(url, {
      body: JSON.stringify(data),
      headers: {"content-type": "application/json", ...headers},
      method: "PATCH"
    })
      .then(response => {
        if (response.redirected) {
          window.location.href = response.url;
        }
        else {
          ShowResponseIfError(response);
          if (response.status === 204) {
            resolve(); return;
          }
          return response.json();
        }
      })
      .then(js => {
        if (js) {
          if ("result" in js) resolve(js.result);
          else resolve(js);
        }
        else {
          resolve();
        }
      })
      .catch((e) => reject(e));
  });
};

export const FetchDelete = (url, headers) => {
  return new Promise((resolve, reject) => {
    fetch(url, { method: "DELETE", headers })
      .then(response => {
        if (response.redirected) {
          window.location.href = response.url;
        }
        else {
          ShowResponseIfError(response);
          if (response.status === 204) {
            resolve(); return;
          }
          return response.json();
        }
      })
      .then(js => {
        if (js) {
          if ("result" in js) resolve(js.result);
          else resolve(js);
        }
        else {
          resolve();
        }
      })
      .catch((e) => reject(e));
  });
};

export const FetchDownloadFile = (url) => {
  return new Promise((resolve, reject) => {
    fetch(url, { method: "GET", headers: CreateHeaders({}) })
      .then((response) => {
        if (response.redirected) {
          window.location.href = response.url;
        }
        else {
          ShowResponseIfError(response);
          if (response.status === 204) {
            return null;
          }
          else {
            return response.blob();
          }
        }
      })
      .then((blob) => {
        const file_url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = file_url;
        a.download = url.split('/').pop();
        console.log(a.href)
        console.log(a.download)
        document.body.appendChild(a);
        a.click();    
        a.remove();
        resolve();
      })
      .catch((e) => reject(e));
  });
};